export function sortFilterOptions<T extends { value: string; name: string; isOther?: boolean }>(
  options: readonly T[],
  preferredValues: readonly string[] = [],
  priorityGroup: readonly string[] = [],
  displayName: (name: string) => string = name => name
): T[] {
  const normalize = (value: string) => value.trim().toLocaleLowerCase('en');
  const preferred = new Set(preferredValues.map(normalize).filter(Boolean));
  const group = new Set(priorityGroup);
  const rank = (option: T): number => {
    if (option.isOther || normalize(option.value) === 'other' || normalize(option.name) === 'other') return 3;
    if (preferred.has(normalize(option.value)) || preferred.has(normalize(option.name))) return 0;
    return group.has(option.value) ? 1 : 2;
  };

  return [...options].sort((first, second) => rank(first) - rank(second) ||
    displayName(first.name).localeCompare(displayName(second.name), 'en', { sensitivity: 'base' }));
}

export function withProfileOptionDivider<T extends { value: string; name: string; isOther?: boolean }>(
  options: readonly T[],
  preferredValues: readonly string[]
): (T & { profileDividerAfter: boolean })[] {
  const normalize = (value: string) => value.trim().toLocaleLowerCase('en');
  const preferred = new Set(preferredValues.map(normalize).filter(Boolean));
  let lastPreferred = -1;

  for (let index = 0; index < options.length; index++) {
    const option = options[index];
    const isOther = option.isOther || normalize(option.value) === 'other' || normalize(option.name) === 'other';
    if (isOther || (!preferred.has(normalize(option.value)) && !preferred.has(normalize(option.name)))) break;
    lastPreferred = index;
  }

  return options.map((option, index) => ({
    ...option,
    profileDividerAfter: index === lastPreferred && index < options.length - 1
  }));
}
